import { Link, useParams } from "react-router-dom";
import Seo from "@/components/Seo";
import { guides } from "@/data/guides";
import NotFound from "@/pages/NotFound";

const GuideDetail = () => {
  const { guideSlug } = useParams();
  let guide = null;
  for (let index = 0; index < guides.length; index += 1) {
    if (guides[index].slug === guideSlug) {
      guide = guides[index];
      break;
    }
  }

  if (!guide) {
    return <NotFound />;
  }

  const sectionBlocks = [];
  for (let index = 0; index < guide.sections.length; index += 1) {
    const section = guide.sections[index];
    sectionBlocks.push(
      <div key={section.title} data-testid={`guide-section-${index}`}>
        <h2 className="font-heading text-2xl uppercase" data-testid={`guide-section-title-${index}`}>
          {section.title}
        </h2>
        <p className="text-brand-ink/70 mt-2" data-testid={`guide-section-body-${index}`}>
          {section.body}
        </p>
      </div>,
    );
  }

  return (
    <div className="bg-white" data-testid="guide-detail-page">
      <Seo title={`${guide.title} | Fast Alu`} description={guide.excerpt} />
      <section className="bg-brand-blue/5" data-testid="guide-detail-hero">
        <div className="max-w-6xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-10">
          <div>
            <p className="text-xs uppercase tracking-wider text-brand-red" data-testid="guide-detail-kicker">
              Guide pratique
            </p>
            <h1 className="font-heading text-4xl uppercase" data-testid="guide-detail-title">
              {guide.title}
            </h1>
            <p className="text-brand-ink/70 mt-4" data-testid="guide-detail-excerpt">
              {guide.excerpt}
            </p>
          </div>
          <div>
            <img
              src={guide.image}
              alt={guide.title}
              className="w-full h-72 object-cover rounded-sm"
              data-testid="guide-detail-image"
            />
          </div>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-6 py-16 space-y-8" data-testid="guide-detail-content">
        {sectionBlocks}
        <Link
          to="/contact"
          className="inline-flex bg-brand-red text-white px-5 py-3 rounded-full uppercase text-xs font-bold"
          data-testid="guide-cta"
        >
          Demander un devis
        </Link>
      </section>
    </div>
  );
};

export default GuideDetail;
